<template>
	<div>
		<common-header navbar-index=2></common-header>
		<robot-banner></robot-banner>
		<div class="container" id="link1">
			<div class="tips mt-5 pt-4 pb-4">
				<a href="javascript:void(0)" @click="toback">行业新闻</a><span class="s1">|</span><span class="s2">教育部成立人工智能科技创新专家组 人工智能行业发展趋势分析</span>
			</div>
			<div class="content_item pt-4 pb-5">
				<div class="pl25 pr25">
					<div class="title mb-4">教育部成立人工智能科技创新专家组 人工智能行业发展趋势分析</div>
					<p class="text">日前，教育部网站发布《教育部办公厅关于成立教育部人工智能科技创新专家组的函》，公布了教育部人工智能科技创新专家组咨询组专家名单和教育部人工智能科技创新专家组工作组专家名单。其中咨询组由高校、企业在人工智能领域具有战略思考、实践经验和影响力的专家学者组成，咨询组主要任务是对高校人工智能人才培养、科技创新和产学研合作等政策、规划提出咨询建议；工作组由开展人工智能领域创新与实践基础好的高校相关专家组成。工作组主要任务是承担咨询组日常工作，并接受教育部委托开展人工智能相关领域专项工作和专题研究等工作。具体名单如下：</p>
					<p style="text-align:center"><img alt="" height="742" src="../../../assets/img/robot/article/4_1.png" width="600"></p>
					<p class="text2">资料来源：教育部、中商产业研究院整理</p>
					<p style="text-align:center"><img alt="" height="657" src="../../../assets/img/robot/article/4_2.png" width="600"></p>
					<p class="text2">资料来源：教育部、中商产业研究院整理</p>
					<p class="text" style="font-weight: 600;">人工智能应用场景不断扩大</p>
					<p class="text">其实除了教育业日益重视人工智能的发展与技术学习，其他诸如金融、汽车等等各个行业都在应用人工智能。人工智能技术的快速发展，对传统行业具有重塑性功能，并且通过改良创新，为行业提供新的辅助性工具，促进行业进步，在金融、交通、健康、安全等诸多领域，起到积极作用。</p>
					<p class="text">首先，机器人市场发展迅速，机器人是公众认知较强的人工智能产物，在线下零售店、家庭儿童教育、养老陪护及家务工作等多种场景落地迅速，机器人产品市场快速成长，如教育机器人、扫地机器人市场;其次，医疗健康领域，人工智能帮助改善医疗资源分布不均的问题，助力医学专家攻坚克难，在语音录入病历、医疗影像分析、诊疗、健康管理、药物研发等方面，都有显著成效;最后，金融领域人工智能应用场景广泛，从身份认证、智能风控到资产管理、投资分析研判，工智能技术革新，与金融领域相辅相成，进一步提高行业安全性。</p>
					<p style="text-align:center"><img alt="" height="406" src="../../../assets/img/robot/article/4_3.jpeg" width="600"></p>
					<p class="text2">图片来源：中商产业研究院整理</p>
					<p class="text" style="font-weight: 600;">人工智能市场规模统计及预测</p>
					<p class="text">2018年上半年，我国人工智能政策不断落地，技术应用商业化进程加快。十八大以来我国的信息化水平大幅提升，互联网用户数量跃居世界第一，信息领域核心技术步深刻改变了人们生活的诸多方面，而人工智能技术和应用飞速发展，带来更为持久深刻的思维与变革。政策层面，国务院发布的《新一代人工智能发展规划》提出“到2030年，使中国成为世界主要人工智能创新中心”。在我国国家战略规划中，人工智能已超越技术概念，上升为国内产业转升级、国际竞争力提升的发展立足点和新机遇;行业应用层面，巨大的行业应用需求场景、研发能力积累与海量的数据资源、开放的市场宏观环境有机结合，形成了我国人工智能发展的独特优势，依靠应用市场广阔前景，推动技术革新，形成技术和市场共同驱动。预计2018年中国人工智能市场规模将达到238.2亿元。</p>
					<p style="text-align:center"><img alt="" height="340" src="../../../assets/img/robot/article/4_4.png" width="600"></p>
					<p class="text2">数据来源：中商产业研究院整理</p>
					<p class="text" style="font-weight: 600;">人工智能行业未来发展趋势</p>
					<p class="text" style="font-weight: 600;">1.在影响就业之前，人工智能将会对雇主产生影响</p>
					<p class="text">长期来看,人工智能不会摧毁就业市场——至少在2018年是不可能的。但是企业面临着一个重大挑战：只有汇集了来自不同种类的数据以及不同学科的团队成员时，人工智能才能发挥出最大的效果。同时，它还需要借助相应的结构和技能来实现人机协作。但是大多数企业都把数据存放在联合企业和团队的数据库里。很少有企业开始为员工提供他们所需要的基本人工智能技能。普通的企业还没有准备好满足人工智能的需求。</p>
					<p class="text" style="font-weight: 600;">2.人工智能将融入现实，开始发挥其效用</p>
					<p class="text">它可能不会成为媒体的头条新闻,但人工智能现在已经准备好了，能够自动完成日益复杂的流程，识别出能够创造商业价值的趋势，并提供具有前瞻性的情报。 这带来的结果是,人们的工作量减少,做出的战略决策也变得更好了：员工的工作也比以前更好了。但是,由于传统的投资回报率（ROI）策略可能无法准确地识别出这一价值，企业将需要考虑采取新的指标，以便更好地理解工智能可以为它们做什么。</p>
					<p class="text" style="font-weight: 600;">3.人工智能将帮助回答有关数据的重大问题</p>
					<p class="text">许多针对数据技术和数据集成的投资都未能回答这样的一个重大问题：投资回报率在哪？现在，人工智能正在为这些数据项目提供商业案例，新的工具将会使这些项目的价值凸显出来。</p>
					<p class="text">企业不再需要决定”清理数据”——也不应该这样做。他们应该首先从一个业务问题开始来量化人工智能的好处。一旦数据被用来解决一个特定的问题，进一步开发数据驱动的人工智能解决方案就会变得更容易，从而就会形成一个良性循环。问题出在了哪里？一些企业仍然在犹豫要不要建立，或者是没有建立好数据基础。</p>
					<p class="text">在未来，人工智能领域的投资将以“AI+行业”的方式展开，预计人工智能应用场景较为成熟且需求强烈的领域，如安防、语音识别、医疗、智慧城市、金融等领域，带来升级转换，提高行业智能化水平，改善企业的盈利能力，预计随着诸如无人驾驶汽车等认知智能技术的加速突破与应用，人工智能市场将加速爆发。</p>

					<p class="text">&nbsp;</p>
					<p style="text-align:left">原文链接：
						<a target="_blank" href="http://www.robotest.cn/article/item-302.html">http://www.robotest.cn/article/item-302.html</a>
					</p>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import RobotBanner from '@/pages/robot/components/RobotBanner'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Article4',
		components: {
			CommonHeader,
			RobotBanner,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {
			toback() {
				this.$router.push({
					path: '/robot/desc'
				})
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
		}
	};
</script>

<style lang="scss" scoped>
	.content_item a {
		color: #000000;
		text-decoration: none;
	}
	
	div.title {
		font-size: 22px;
		font-weight: 600;
		text-align: center;
		letter-spacing: 2px;
	}
	
	p.tag {
		font-size: 20px;
		font-weight: 600;
		margin-top: 30px;
	}
	
	p.text {
		font-size: 16px;
		line-height: 30px;
		letter-spacing: 1px;
	}
	
	p.text2 {
		font-size: 16px;
		text-align: center;
	}
	
	div.tips {
		border-bottom: 3px solid #F0F0F0;
		a {
			font-size: 24px;
			font-weight: 600;
			color: #333;
			text-decoration: none;
			cursor: pointer;
			letter-spacing: 2px;
			&:hover {
				color: #f39c12;
			}
		}
		.s1 {
			padding: 0 15px;
		}
		.s2 {
			letter-spacing: 2px;
			font-size: 18px;
		}
	}
</style>